/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Usage_Chat_ReviewInputs */

const en_usage_chat_review = /** @type {(inputs: Usage_Chat_ReviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chat review`)
};

const nl_usage_chat_review = /** @type {(inputs: Usage_Chat_ReviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chatreview`)
};

/**
* | output |
* | --- |
* | "Chat review" |
*
* @param {Usage_Chat_ReviewInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const usage_chat_review = /** @type {((inputs?: Usage_Chat_ReviewInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Usage_Chat_ReviewInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_usage_chat_review(inputs)
	return en_usage_chat_review(inputs)
});